import { isKeyHotkey } from "is-hotkey";
import * as SL from "slate";
import { toggleMark } from "../../components/toolbar/duck";
import { CustomEditor, EditorEventListeners } from "../../duck";
import { nodeTypes } from "./constants";
import { Element } from "./types";

export const isElementEmpty = (element: Element): boolean => {
  if (
    nodeTypes.indexOf(element.type || "paragraph") >= -1 &&
    element.children
  ) {
    return element.children.every(isElementEmpty);
  }

  if (!element.type) {
    return !element.text?.trim();
  }

  return false;
};

export const onKeyDown = (
  editor: CustomEditor
): EditorEventListeners["onKeyDown"] => event => {
  const { selection } = editor;

  if (
    window.getSelection()?.anchorNode?.parentElement?.nodeName !== "SPAN" ||
    window.getSelection()?.focusNode?.parentElement?.nodeName !== "SPAN"
  ) {
    /*
     * Working around error
     * "Uncaught Error: Cannot resolve a Slate point from DOM point: [object Text],16"
     * In case when cursor in the middle of elements.
     * Slate always printing text nodes inside span.
     * */
    event.preventDefault();
  }

  // Default left/right behavior is unit:'character'.
  // This fails to distinguish between two cursor positions, such as
  // <inline>foo<cursor/></inline> vs <inline>foo</inline><cursor/>.
  // Here we modify the behavior to unit: 'offset'.
  // This lets the user step into and out of the inline without stepping over characters.
  // You may wish to customize this further to only use unit: 'offset' in specific cases.
  if (selection && SL.Range.isCollapsed(selection)) {
    const { nativeEvent } = event;
    if (isKeyHotkey("left", nativeEvent)) {
      event.preventDefault();
      SL.Transforms.move(editor, { unit: "offset", reverse: true });
      return;
    }

    if (isKeyHotkey("right", nativeEvent)) {
      event.preventDefault();
      SL.Transforms.move(editor, { unit: "offset" });
      return;
    }

    if (isKeyHotkey("tab", nativeEvent)) {
      event.preventDefault();
      editor.insertText(String.fromCodePoint(9)); // tab symbol
    }
  }

  if (isKeyHotkey("mod+b", event)) {
    event.preventDefault();
    toggleMark(editor, "bold");
  }

  if (isKeyHotkey("mod+i", event)) {
    event.preventDefault();
    toggleMark(editor, "italic");
  }

  if (isKeyHotkey("mod+u", event)) {
    event.preventDefault();
    toggleMark(editor, "underline");
  }
};
